import React, { forwardRef, ForwardRefRenderFunction } from 'react';
import {
  Box,
  Grid,
  Paper,
} from '@mui/material';
import {
  LabelPrinterPdfProp, LabelPrinterPdfRef,
} from '@/pages/specialPriceTable/searchSpecialPriceList/components/driverCarriesSpecialRateMeterPdf/labelPrinterPdf/type';
import image from '@/pages/specialPriceTable/searchSpecialPriceList/images/specialPrice.png';
import PdfA4Tool from '@/components/pdfTool/pdfA4ToolIndex';

const Pdf:
    ForwardRefRenderFunction<LabelPrinterPdfRef, LabelPrinterPdfProp> = (props, ref) => {
      const { PdfPaperId, PdfDto, ClassName } = props;

      return (
        <PdfA4Tool className={ClassName} PdfPaperId={PdfPaperId} image={image}>

            <Grid spacing={1} container sx={{ paddingLeft: '5px' }}>
                {
                    PdfDto.PdfItem.map((row, index) => (
                        <Grid key={index} item xs={4}>
                            <Box sx={{
                              width: 240,
                              height: 100,
                              borderRadius: '15px',
                              padding: '5px',
                              borderStyle: 'solid',
                              borderWidth: '2px',
                              backgroundColor: 'white', // 设置白色底色
                              overflow: 'hidden', // 防止出现滚动条
                              fontSize: '12px',
                              textOverflow: 'ellipsis', // 省略号处理
                              display: 'block',
                              whiteSpace: 'normal', // 允许换行
                              wordWrap: 'break-word', // 换行处理
                            }}>
                                <Box sx={{
                                  width: '100%',
                                  height: '75%',
                                }}>
                                    TO : {row.CustomerName} <br/>
                                    {row.CustomerAddress} <br/>
                                    {row.CityAndStateAndZipCode}
                                </Box>
                                <Box sx={{
                                  width: '100%',
                                  height: '25%',
                                  marginLeft: 'auto',
                                  paddingLeft: '50%',
                                }}>
                                    {row.Subscript}
                                </Box>
                            </Box>
                        </Grid>
                    ))
                }
            </Grid>
        </PdfA4Tool>
      );
    };

export default forwardRef(Pdf);
